import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { useApiMessageList } from '@/features/logs-management/api-logs/hooks/useApiMessageList';
import { ApiLogsTable } from '@/features/logs-management/api-logs/table';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { FileCode } from 'lucide-react';
import { z } from 'zod';

const apiMessagesSchema = z
  .object({
    createdDate: z.string().optional(),

    q: z.string().optional(),

    page: z.coerce.number().positive().catch(0),
    fetch: z.coerce.number().positive().max(100).catch(10),
  })
  .passthrough();

export const Route = createFileRoute('/(app)/logs-management/api-logs/')({
  loader: () => {
    return {
      crumb: <CrumbTitle id="logsManagement.sidebar.menu.apiLogs" icon={FileCode} />,
      title: <Translation id="logsManagement.sidebar.menu.apiLogs" />,
    };
  },
  errorComponent: ({ error }) => {
    return <div>{error.message}</div>;
  },
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => apiMessagesSchema.parse(search),
});

function RouteComponent() {
  const { apiMessages, isLoading, pagination } = useApiMessageList();
  return <ApiLogsTable data={apiMessages} isLoading={isLoading} pagination={pagination} />;
}
